import React, { useEffect, useRef, useState } from "react";
import "./ratechart.css";

const n = (v) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

export default function StepDialog({
  open,
  title = "Steps",
  onClose,
  onApply, // (item:{step:number, amount:number}, keepOpen:boolean) => void
}) {
  const [step, setStep] = useState("0.0");
  const [amount, setAmount] = useState("0.00");
  const [keepOpen, setKeepOpen] = useState(false);

  const stepRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    // reset each time opened (like Android)
    setStep("0.0");
    setAmount("0.00");
    setKeepOpen(false);

    // focus input
    setTimeout(() => stepRef.current?.focus?.(), 0);
  }, [open]);

  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const apply = () => {
    const st = n(step);
    const amt = n(amount);

    // basic validate
    if (!Number.isFinite(st)) return;
    if (!Number.isFinite(amt)) return;

    onApply?.(
      {
        step: Number(st.toFixed(1)),
        amount: Number(amt.toFixed(2)),
      },
      keepOpen
    );

    if (keepOpen) {
      setStep("0.0");
      setAmount("0.00");
      setTimeout(() => stepRef.current?.focus?.(), 0);
    } else {
      onClose?.();
    }
  };

  return (
    <div className="rcStepBackdrop" onMouseDown={() => onClose?.()}>
      <div
        className="rcStepModal"
        onMouseDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="rcStepHead">
          <div className="rcStepTitle">{title}</div>
          <button className="rcStepClose" onClick={() => onClose?.()} title="Close">
            ×
          </button>
        </div>

        <div className="rcStepBody">
          <div className="rcStepGrid">
            <div className="rcStepLabel">Step :</div>
            <input
              ref={stepRef}
              className="rcStepInput"
              value={step}
              onChange={(e) => setStep(e.target.value)}
              inputMode="decimal"
            />

            <div className="rcStepLabel">Step Amount :</div>
            <input
              className="rcStepInput"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              inputMode="decimal"
            />
          </div>

          <label className="rcStepCheckRow">
            <input
              type="checkbox"
              checked={keepOpen}
              onChange={(e) => setKeepOpen(e.target.checked)}
            />
            <span>Save And Add Another</span>
          </label>

          <div className="rcStepActions">
            <button className="rcStepBtn" onClick={() => onClose?.()}>
              Cancel
            </button>
            <button className="rcStepBtn primary" onClick={apply}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
